// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassFilledSvg from "@fishx/icons-svg/es/asn/HourglassFilled";
import FishxIcon from '../components/FishxIcon';

var HourglassFilled = function HourglassFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassFilledSvg
  }));
};

HourglassFilled.displayName = 'HourglassFilled';
export default React.forwardRef(HourglassFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HourglassFilled.js
// module id = 2942
// module chunks = 0